import getLinkText from "../../../helpers/getLinkText";
import getArticleDetail from "../../../helpers/getArticleDetail";
import { trackEvent } from "../../../trackEvent";

/**
 * Push any link with data-gtm-article to datalayer
 * 
 *  <a href="" data-gtm-article>
 *     Link Text
 *  </a>
 */


const test = ({ target }) => target.hasAttribute("data-gtm-article");

const push = ({ link, target }) => {
  const articleDetail = getArticleDetail({ target });
  trackEvent({
    event: 'click_article',
    event_type: 'click',
    article_name: articleDetail.title,
    element_text: getLinkText({ target }),
    element_url: link,
    publication_date: articleDetail.publishDate,
    tags: articleDetail.tags
  });
}

export default {
  name: "article",
  test,
  push
};